export default {"src":"/_next/static/image/public/coin.40b55dba4f71b82240b8743b5ea34e21.svg","height":24,"width":24};